import { OrgAdminPage } from "@/pages/org-admin";

export function StudioOrgAdminPage() {
  return <OrgAdminPage />;
}
